<script>
    import Layout from "../../layout/mainLayout";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import axios from 'axios';
    /*
     * View Admin
     */
    export default {
        page: {
            title: "View Admin",
            meta: [{
                name: "description"
            }]
        },
        components: {
            Layout,
            PageHeader
        },
        data() {
            return {
                name: 'View Admin',
                title: "View Admin",
                items: [{
                    text: "Admins",
                    href: "/admins"
                }],
                form: {
                    name: "",
                    email: "",
                    mobile_phone: "",
                    password: "",
                    isActive: 0,
                    permissions: [],
                },
                errors: null,
                submitted: false,
                pending: false,
                permissionsList: [],
                select_all_permissions: false,
                currrentAdmin: {}
            };
        },
        methods: {
            async getCurrentAdmin() {
                let that = this;
                await axios.get(appConfig.admins.edit+this.$route.params.id).then(function(response){
                    that.currrentAdmin = response.data.admin;
                    that.currrentAdmin['permissions'] = response.data.permissions;
                    that.form = that.currrentAdmin;
                    that.form.password = ''; // don't remove this
                });
            },
            async getPermissionsList() {
                let that = this;
                await axios.get(appConfig.permissions.list).then(function (response) {
                    that.permissionsList = response.data.permissions;
                });
            }
        },
        created() {            
            this.pending = true;
            axios.all([
                this.getPermissionsList(),
                this.getCurrentAdmin()
            ]).finally(() => this.pending = false );
        },
    };

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card" id="error_area">
                    <div class="card-body">

                        <FormValidation :errors="errors" />

                        <form class="needs-validation">

                            <fieldset disabled="true">

                                <div class="row">

                                    <div class="col-sm-6">

                                        <div class="form-group mb-3">
                                            <label for="name">Name</label>
                                            <input type="text" v-model="form.name" class="form-control" id="name"
                                                placeholder="Enter name" />
                                        </div>
                                        <div class="form-group mb-3">
                                            <label for="email">Email</label>
                                            <input type="text" v-model="form.email" class="form-control" id="email"
                                                placeholder="Enter email" />
                                        </div>

                                    </div>
                                    <div class="col-sm-6">

                                        <div class="form-group mb-3">
                                            <label for="mobile_phone">Mobile Number</label>
                                            <input v-model="form.mobile_phone" type="text" class="form-control" id="mobile_phone"
                                                placeholder="Enter Mobile Number" />
                                        </div>

                                    </div>
                                    <div class="col-sm-12">
                                        <div class="custom-control custom-checkbox isActiveCheck">
                                            <input v-model="form.isActive" type="checkbox" class="custom-control-input" id="isActive" />
                                            <label class="custom-control-label" for="isActive">Active Account</label>
                                        </div>
                                    </div>

                                </div>
                                <!-- row -->

                                <div class="row" v-if="permissionsList.length > 0">

                                    <div class="col-lg-12">

                                        <hr>

                                        <h6 class="mt-1"><strong>Permissions</strong></h6>

                                        <div class="mt-2 permissions">
    
                                            <div v-for="permission in permissionsList" :key="permission" class="col-lg-3 custom-control custom-checkbox">
                                                <input v-model="form.permissions" type="checkbox" class="custom-control-input" :value="permission" :id="permission"  />
                                                <label class="custom-control-label" :for="permission">{{ permission.replaceAll("_", " ")  }}</label>
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <!-- col-lg-12 -->
                                </div>

                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
    .permissions .custom-control-label {text-transform: capitalize}
    .permissions .custom-checkbox {display: inline-block;}
</style>
